<div class="countdown" (togglePlayertEmitter)="togglePlayertEmitter">
  <p class="countdown__time">{{time | number:'2.0'}}:00</p>
</div>
